import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerFailedToSharePartnerPrivateKeyError extends BaseEitherError {}

export type TKeysManagerSharePartnerPrivateKeyOperationErrors =
  KeysManagerFailedToSharePartnerPrivateKeyError;
